module.exports = __webpack_public_path__ + "img/atm_env.b61054f2.svg";